angular.module('tgaAdmin').controller('BannerPageController', [
  'bannerNotificationsService',
  '$scope',
  'modalService',
  '$translate',
  function (bannerNotificationsService, $scope, modalService, $translate) {
    $scope.viewmodel = {
      banners: [],
    };
    $scope.loading = false;

    $scope.getAllBanners = () => {
      $scope.loading = true;
      bannerNotificationsService
        .getAll()
        .then((data) => {
          $scope.viewmodel.banners = data;
        })
        .finally(() => {
          $scope.loading = false;
        });
    };

    $scope.createAlert = (msg, type) => {
      $scope.data.alerts = [];
      $scope.data.alerts.push({
        msg,
        type,
      });
    };

    $scope.deleteBanner = (banner) => {
      modalService
        .showModal(
          {
            title: $translate.instant('banner.delete.title').toString(),
            message: $translate.instant('banner.delete.message', { message: banner.message }).toString(),
            closeButton: $translate.instant('common.cancel').toString(),
            actionButton: $translate.instant('common.delete'),
            actionClass: 'danger',
          },
          {
            backdrop: true,
            keyboard: true,
            animation: false,
          },
        )
        .then(
          () => {
            $scope.loading = true;
            bannerNotificationsService.del(banner.banner_id).then(() => {
              $scope.createAlert(
                `<span class="fa fa-check"></span> ${$translate.instant('banner.deleted_success').toString()}`,
                'success',
              );
              $scope.getAllBanners();
              bannerNotificationsService.getBannersAndCache();
            });
          },
          () => {},
        );
    };

    $scope.getAllBanners();
  },
]);
